import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { InputSelect } from '../../InputSelect';
import QuestionTitle from './QuestionTitle';
import QuestionSubTitle from './QuestionSubTitle';
import QuestionOptionsContainer from './QuestionOptionsContainer';

export const MultipleDropdownSelect = ({ question, value, onChange }) => {
  const { id, title, subtitle, options } = question;

  return (
    <Grid key={id}>
      <QuestionTitle label={title} />

      {subtitle && <QuestionSubTitle label={subtitle} />}

      <QuestionOptionsContainer>
        <InputSelect
          id={id}
          options={options}
          values={value ?? []}
          isMultipleSelection
          onChange={onChange}
        />
      </QuestionOptionsContainer>
    </Grid>
  );
};

MultipleDropdownSelect.propTypes = {
  question: PropTypes.object.isRequired,
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};
